import '../vendor/jquery.zoom.min.js';

function productImages(){
  $('.product__images ul').on('init', function(slick){
    $(slick.currentTarget).find('img').wrap('<span style="display:inline-block"></span>').css('display', 'block').parent().zoom({
      on: 'click'
    });
  });
  $('.product__images ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    dots: true,
    adaptiveHeight: true
  })
}

export default productImages();



// WEBPACK FOOTER //
// ../markup/assets/js/product-images.js